// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1Cu8G","footer":"ModalError_footer__EmuLd"};